import { NavLink } from "react-router-dom";
import { useDrag, useDrop } from "react-dnd";
import { ItemTypes } from "./constants";
import FilmanizeCheckbox from "../../../../shared/filmanize-checkbox";

function SetDressing(props) {
  const {
    prop,
    filmId,
    aliasSetDressing,
    unaliasSetDressing,
    readOnly,
    processingSetDressingIds = [],
    isSelected,
    onToggleSelect
  } = props;

  const hasAliases = (prop.aliases || []).length > 0;
  const isProcessing = processingSetDressingIds.includes(prop.id);

  const setDressingDropped = (alias) => {
    aliasSetDressing(filmId, alias, prop);
  };

  const canDropSetDressing = (item, monitor) => {
    const itemIsProcessing = processingSetDressingIds.includes(item.prop.id);
    return !readOnly && !isProcessing && !itemIsProcessing && item.prop.id != prop.id;
  };

  const canDragSetDressing = (monitor) => {
    return !readOnly && !hasAliases && !isProcessing;
  };

  const [{ isOverSetDressing }, dropSetDressing] = useDrop({
    accept: ItemTypes.SET_DRESSING,
    drop: (item: any, monitor) => setDressingDropped(item.prop),
    canDrop: (item, monitor) => canDropSetDressing(item, monitor),
    collect: (monitor) => ({
      isOverSetDressing: !!monitor.isOver()
    })
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.SET_DRESSING, prop },
    canDrag: (monitor) => canDragSetDressing(monitor),
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging()
    })
  });

  const getItemStyle = (isDragging) => ({
    background: isDragging ? "#947eed" : "#040f21"
  });

  return (
    <>
      <tr ref={drag}
        style={{
          cursor: !hasAliases && !readOnly && !isProcessing ? "grab" : "",
          opacity: isProcessing ? 0.5 : 1
        }}>
        {!readOnly && (
          <td>
            <FilmanizeCheckbox
              checked={isSelected}
              onChange={onToggleSelect}
            />
          </td>
        )}
        <td ref={dropSetDressing} style={getItemStyle(isOverSetDressing)}>
          {!readOnly && !hasAliases && !isProcessing && (
            <i className="material-icons dark">drag_indicator</i>
          )}
          <NavLink to={`/films/${filmId}/set-dressings/${prop.id}/edit`}>
            {prop.name}
          </NavLink>
        </td>
        <td>
          {prop.quantity}
        </td>
        <td>
          {prop.quantityAcquired}
        </td>
        <td>
          {prop.acquisitionMethodDescription}
        </td>
      </tr>
      {(prop.aliases || []).map((alias) => {
        const aliasIsProcessing = processingSetDressingIds.includes(alias.id);
        return (
          <tr key={alias.id} style={{ opacity: aliasIsProcessing ? 0.5 : 1 }}>
            {!readOnly && <td></td>}
            <td colSpan={4}>
              <div style={{ marginLeft: 30 }}>
                {alias.name}
                &nbsp;
                {!readOnly && !aliasIsProcessing && !isProcessing && (
                  <a onClick={() => unaliasSetDressing(filmId, alias, prop)}>
                    <i className="material-icons">cancel</i>
                  </a>
                )}
              </div>
            </td>
          </tr>
        );
      })}
    </>
  );
}

export default SetDressing;
